import { render, staticRenderFns } from "./NutCheckbox.vue?vue&type=template&id=f8f05720&scoped=true&"
import script from "./NutCheckbox.vue?vue&type=script&lang=js&"
export * from "./NutCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NutCheckbox.vue?vue&type=style&index=0&id=f8f05720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f05720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f05720')) {
      api.createRecord('f8f05720', component.options)
    } else {
      api.reload('f8f05720', component.options)
    }
    module.hot.accept("./NutCheckbox.vue?vue&type=template&id=f8f05720&scoped=true&", function () {
      api.rerender('f8f05720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NutCheckbox.vue"
export default component.exports